import React from 'react';
import styled from 'styled-components';
import truncate from 'lodash/truncate';

import Caption from '@joinforma/ui/components/Caption';
import Body2 from '@joinforma/ui/components/Body2';

import WalletIcon from 'components/common/WalletIcon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0 40px 0;
`;

const DescriptionContainer = styled.div`
  max-width: 80%;
  margin-bottom: 40px;
`;
const Description = styled(Body2)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const AccountIconsContainer = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
`;

const AccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 15px 15px;
`;

const AccountName = styled(Caption)`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const StyledWalletIcon = styled(WalletIcon).attrs({
  alt: 'wallet',
})`
  width: 74px;
  height: 74px;
`;

const LinkedAccounts = ({
  employee_wallets,
}: {
  employee_wallets: {
    id: string;
    wallet_type_id: string;
    company_wallet_configuration: {
      wallet_name: string;
    };
  }[];
}) => (
  <Container>
    <DescriptionContainer>
      <Description>
        Use this card for all your lifestyle benefits - we'll figure out which
        account your purchases are eligible for.
      </Description>
    </DescriptionContainer>
    <AccountIconsContainer>
      {employee_wallets.map(
        ({
          id,
          wallet_type_id,
          company_wallet_configuration: { wallet_name },
        }: {
          id: string;
          wallet_type_id: string;
          company_wallet_configuration: {
            wallet_name: string;
          };
        }) => (
          <AccountContainer key={id}>
            <StyledWalletIcon wallet_type_id={wallet_type_id} />
            <AccountName>{truncate(wallet_name, { length: 10 })}</AccountName>
          </AccountContainer>
        )
      )}
    </AccountIconsContainer>
  </Container>
);

export default LinkedAccounts;
